import { React, Component } from "react";
import MTSNavScrollbar from "../Navbars/MTSNavScrollbar";
import MTSFooter from "../Footers";



const mainStyle = {
    backgroundColor: '#f2f3f3'
};

const mainContainerStyle = {
    backgroundColor: '#ffffff',
    paddingLeft: '0px',
    paddingRight: '0px'
};



class Landing extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {

    };

    render() {
        return (
            <>
                <div class="testimonials-clean">
                    <div class="container">
                        <div class="intro">
                            <h2 class="text-center">Welcome to MTS ordering platform</h2>
                            <p class="text-center">Please login by clicking the Sign link on the top left menu.</p>
                        </div>
                        <div class="row people">
                            <div class="col-md-6 col-lg-4 item">
                                <div class="box">
                                    <p class="description">Aenean tortor est, vulputate quis leo in, vehicula rhoncus lacus. Praesent aliquam in tellus eu gravida. Aliquam varius finibus est.</p>
                                </div>
                                <div class="author"></div>
                            </div>
                            <div class="col-md-6 col-lg-4 item">
                                <div class="box">
                                    <p class="description">Praesent aliquam in tellus eu gravida. Aliquam varius finibus est, et interdum justo suscipit id.</p>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4 item">
                                <div class="box">
                                    <p class="description">Aliquam varius finibus est, et interdum justo suscipit. Vulputate quis leo in, vehicula rhoncus lacus. Praesent aliquam in tellus eu.</p>
                                </div>
                                <div class="author"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Landing;